export default "__VITE_ASSET__Cag_yAVZ__"